// Get Customer Concerns
export const GET_CUSTOMER_CONCERNS_REQUEST = 'GET_CUSTOMER_CONCERNS_REQUEST';
export const GET_CUSTOMER_CONCERNS_SUCCESS = 'GET_CUSTOMER_CONCERNS_SUCCESS';
export const GET_CUSTOMER_CONCERNS_FAIL = 'GET_CUSTOMER_CONCERNS_FAIL';
export const UPDATE_CUSTOMER_CONCERNS = 'UPDATE_CUSTOMER_CONCERNS';

// get problem and job type list

export const GET_PROBLEM_AND_JOB_TYPE_LIST_REQUEST =
  'GET_PROBLEM_AND_JOB_TYPE_LIST_REQUEST';
export const GET_PROBLEM_AND_JOB_TYPE_LIST_SUCCESS =
  'GET_PROBLEM_AND_JOB_TYPE_LIST_SUCCESS';
export const GET_PROBLEM_AND_JOB_TYPE_LIST_FAIL =
  'GET_PROBLEM_AND_JOB_TYPE_LIST_FAIL';

export const CLEAR_GET_PROBLEM_AND_JOB_TYPE_LIST_STATES =
  'CLEAR_GET_PROBLEM_AND_JOB_TYPE_LIST_STATES';

// update problem ot job type

export const ADD_EDIT_PROBLEM_OR_JOB_TYPE_REQUEST =
  'ADD_EDIT_PROBLEM_OR_JOB_TYPE_REQUEST';
export const ADD_EDIT_PROBLEM_OR_JOB_TYPE_SUCCESS =
  'ADD_EDIT_PROBLEM_OR_JOB_TYPE_SUCCESS';
export const ADD_EDIT_PROBLEM_OR_JOB_TYPE_FAIL =
  'ADD_EDIT_PROBLEM_OR_JOB_TYPE_FAIL';
export const CLEAR_ADD_EDIT_PROBLEM_OR_JOB_TYPE_STATES =
  'CLEAR_ADD_EDIT_PROBLEM_OR_JOB_TYPE_STATES';

// delete problem ot job type list

export const DELETE_PROBLEM_OR_JOB_TYPE_REQUEST =
  'DELETE_PROBLEM_OR_JOB_TYPE_REQUEST';
export const DELETE_PROBLEM_OR_JOB_TYPE_SUCCESS =
  'DELETE_PROBLEM_OR_JOB_TYPE_SUCCESS';
export const DELETE_PROBLEM_OR_JOB_TYPE_FAIL =
  'DELETE_PROBLEM_OR_JOB_TYPE_FAIL';
export const CLEAR_DELETE_PROBLEM_OR_JOB_TYPE_STATES =
  'CLEAR_DELETE_PROBLEM_OR_JOB_TYPE_STATES';
